import { v4 } from 'uuid';

const newGuid = (): string => v4();

export default newGuid;
